import React, { ReactNode, useState } from 'react';
import { FormContainer } from 'components/FormContainer';
import { Button } from 'vetrf-ui';
import { DefaultFindFnParams, ExcelFields, FindFnParams, SortOrders } from '../../types/api';

import styles from './RegistrySorting.module.scss';
import { SortingFields } from './SortingFields';
import { ExportExcelModal } from '../ExportExcelModal';

type RegistrySortingProps<T> = {
  onSortingChange?: (item: Partial<DefaultFindFnParams>) => void;
  sortingOptions?: SortOrders[];
  defaultOptions?: SortOrders;
  excelFields?: ExcelFields[];
  findParams?: FindFnParams<T>;
  groupByField?: ExcelFields;
  customBtns?: ReactNode;
  exportMethod?: (data: DefaultFindFnParams) => Promise<void>;
  exportLoading?: boolean;
};

export const RegistrySorting = <T,>({
  onSortingChange,
  sortingOptions,
  defaultOptions,
  excelFields,
  findParams,
  groupByField,
  customBtns,
  exportMethod,
  exportLoading,
}: RegistrySortingProps<T>) => {
  const defaultValues = { sorting: defaultOptions };
  const [isAsc, setIsAsc] = useState<boolean>(defaultOptions?.asc || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = (sorting: SortOrders) => {
    const formattedValue = [{ field: sorting.field, asc: isAsc }];
    onSortingChange?.({ sortOrders: formattedValue });
  };
  const handleToggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };
  return (
    <>
      <FormContainer
        onSubmit={handleSubmit}
        formConfig={{ defaultValues }}
        className={styles.formWrapper}
      >
        {excelFields ? (
          <Button
            color="success"
            icon="download"
            iconColor="white"
            iconSize={120}
            size="sm"
            text="Excel"
            onClick={handleToggleModal}
          />
        ) : (
          findParams &&
          exportMethod && (
            <Button
              color="success"
              icon={exportLoading ? 'spinner' : 'download'}
              iconClassName={exportLoading ? 'fa-spin' : undefined}
              disabled={exportLoading}
              iconColor="white"
              iconSize={120}
              size="sm"
              text="Excel"
              onClick={() => exportMethod(findParams)}
            />
          )
        )}
        {customBtns!}
        {!!sortingOptions && (
          <div className={styles.sortingBlock}>
            <h5 className={styles.sortingLabel}>Сортировка</h5>
            <SortingFields
              handleSumbit={handleSubmit}
              isAsc={isAsc}
              setIsAsc={setIsAsc}
              sortingOptions={sortingOptions}
            />
          </div>
        )}
      </FormContainer>
      {isModalOpen && excelFields && (
        <ExportExcelModal
          excelFields={excelFields}
          findParams={findParams}
          onClose={handleToggleModal}
          groupByField={groupByField}
          exportMethod={exportMethod}
        />
      )}
    </>
  );
};
